import React, { useState } from 'react';

const Vector = ({ v }) => {
  const [show, setShow] = useState(false);
  const s = v.split(':');
  const key = s[0];
  const val = s[1];
  const parseVector = (v) => {
    const vectorKey = {
      CVSS: {
        name: 'CVSS Version',
        value: val,
      },
      AV: {
        name: 'Attack Vector',
        value: {
          N: 'Network',
          A: 'Adjacent Network',
          L: 'Local',
          P: 'Physical',
        },
      },
      AC: {
        name: 'Attack Complexity',
        value: {
          L: 'Low',
          H: 'High',
        },
      },
      PR: {
        name: 'Privileges Required',
        value: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      UI: {
        name: 'User Interaction',
        value: {
          N: 'None',
          R: 'Required',
        },
      },
      S: {
        name: 'Scope',
        value: {
          U: 'Unchanged',
          C: 'Changed',
        },
      },
      C: {
        name: 'Confidentiality Impact',
        value: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      I: {
        name: 'Integrity Impact',
        value: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      A: {
        name: 'Availability Impact',
        value: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
    };

    if (vectorKey[key] && vectorKey[key].value[val]) {
      return (
        <>
          <span className='label'>{vectorKey[key].name}</span>
          <span>{vectorKey[key].value[val]}</span>
        </>
      );
    } else if (key === 'CVSS' && vectorKey[key].value) {
      return (
        <>
          <span className='label'>{vectorKey[key].name}</span>
          <span>{vectorKey[key].value}</span>
        </>
      );
    }
    return null;
  };
  const vLabel = parseVector(v);
  return (
    <span
      onMouseOver={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={vLabel && { cursor: 'help' }}
    >
      {v}
      {vLabel ? (
        <i style={{ display: show ? 'block' : 'none', position: 'absolute' }}>
          {vLabel}
        </i>
      ) : null}
    </span>
  );
};

const CveVectors = ({ vectors }) => {
  const vectArr = vectors.split('/');

  return (
    <span className='vector-decorate'>
      {vectArr.map((v, i) => (
        <Vector v={v} key={`vector-${i}`} />
      ))}
    </span>
  );
};

export default CveVectors;
